// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2G3cM","info":"Note_info__1-Lwq","note":"Note_note__36xuT","actions":"Note_actions__1D2FY"};